import React from "react";
import ISOContent from "../../../components/ISO Certificates/ISO 9001-2015/ISOContent9001";
import ISOBenifit9001 from "../../../components/ISO Certificates/ISO Common/ISOBenifit9001";
import ISOCertificationCost9001 from "../../../components/ISO Certificates/ISO Common/ISOCertificationCost9001";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOHeader9001 from "../../../components/ISO Certificates/ISO 9001-2015/ISOHeader9001";

const ISO90012015 = () => {
  return (
    <div>
      <ISOHeader9001 />
      <ISOContent />
      <ISOServiceIndia9001 />
      <ISOCertificationCost9001 />
      <ISOBenifit9001 />
    </div>
  );
};

export default ISO90012015;
